// extracted by mini-css-extract-plugin
export var fullWidthButton = "_o0-0";